var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex number-input"},[_c('button',{staticClass:"subtract",on:{"click":_vm.decrement}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.localValue))]),_vm._v(" "),_c('button',{staticClass:"add",on:{"click":_vm.increment}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af4f8ada","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-cart/components/NumberInput.vue
// module id = Hwzu
// module chunks = 1